<button [class.accordion-style]="accordionStyle" (click)="isOpen = !isOpen">
  <p class="link">
    {{ 'MMR.' + (isOpen ? 'HIDE' : 'SHOW') + '_CONTACT_HOURS' | translate }}
  </p>
  <dgx-components-icon [name]="isOpen ? 'chevron-up' : 'chevron-down'">
  </dgx-components-icon>
</button>

<section
  class="content"
  [style.height.px]="isOpen ? InformationReference.offsetHeight + 12 : 0"
>
  <section class="information" #InformationReference>
    <section *ngIf="showOpeningHoursTitle" class="row">
      <p>{{ 'MMR.OPENING_HOURS' | translate }}</p>
    </section>

    <section *ngFor="let day of order" class="row">
      <p style="text-transform: capitalize">{{ day }}</p>
      <p
        *ngIf="
          contactHours[day] &&
            contactHours[day].openingTime !== contactHours[day].closingTime;
          else ClosedState
        "
      >
        {{ contactHours[day].openingTime | timeFormat }} -
        {{ contactHours[day].closingTime | timeFormat }}
      </p>
      <ng-template #ClosedState>
        <p>{{ 'MMR.CLOSED' | translate }}</p>
      </ng-template>
    </section>
  </section>
</section>
